import {Injectable} from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class EventsService {
    private listeners;
    private eventsSubject;
    private events;


    constructor() {
        this.listeners = {};
        this.eventsSubject = new Rx.Subject();

        this.events = Rx.Observable.from(this.eventsSubject);

        this.events.subscribe(
            ({name, args}) => {
                if (this.listeners[name]) {
                    for (let listener of this.listeners[name]) {
                        listener(...args);
                    }
                }
            });
    }

    on(name, listener, context?) {
        if (!this.listeners[name]) {
            this.listeners[name] = [];
        }
        if(context){
            listener = listener.bind(context);
        }
        this.listeners[name].push(listener);
    }

    broadcast(name, ...args) {
        this.eventsSubject.next({
            name,
            args
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/events.service.ts